/* eslint no-undef: "error" */

import React, { useState, useEffect } from "react";
import { object, array, func } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Headline from "../../atoms/headline";
import Carousel from "../../atoms/carousel";
import Arrow1 from "../../atoms/icons/arrow-1";
import Arrow2 from "../../atoms/icons/arrow-2";
import CardImageType2 from "../../molecules/card-image-type-2";
import CardImageType5 from "../../molecules/card-image-type-5";
import PublicationsRow from "../../rows/publications";
import PeopleTeamRow from "../../rows/people-team";
import Entities from "../../molecules/entities";

import { setPublicationStories, setLoading } from "../../helper/actions";
import { getSectionStories } from "../../helper/api";
import SupportBanner from "../../molecules/support-banner";

import "./section.m.css";

const CollectionDom = ({ collection }) => {
  const collectionStories =
    collection.items &&
    collection.items.filter(
      item =>
        item.type === "story" &&
        item.story &&
        (item.story["story-template"] === "project" || item.story["story-template"] === "text") &&
        item.story["hero-image-s3-key"] != null
    );

  if (!collectionStories) {
    return null;
  }

  return (
    <div styleName="collection-item-wrapper">
      <Headline text={collection.name} headerType={9} headerLevel={2} />
      <p styleName="description">{collection.summary}</p>
      <div styleName="collection-stories">
        {collectionStories.slice(0, 15).map(
          (story, key) =>
            story && (
              <div key={key}>
                <CardImageType5 story={story} />
              </div>
            )
        )}
      </div>
    </div>
  );
};

CollectionDom.propTypes = {
  collection: object
};

const Subcollections = ({ collections }) =>
  collections.map(collection => <CollectionDom key={collection.id} collection={collection} />);

Subcollections.propTypes = {
  collections: array
};

const getAllAuthors = ({ collection }) => {
  const subCollections = collection.items.filter(item => item.type === "collection");
  const fillerStoryAuthors = get(collection, ["items", "0", "story", "authors"], []);
  const authorList = [];

  if (collection.id !== 29145) {
    subCollections.forEach(collectionObj => {
      const stories = collectionObj.items.filter(
        item =>
          item.type === "story" &&
          item.story["story-template"] === "project" &&
          item.story.authors &&
          item.story.authors.length
      );

      stories.forEach(({ story }) => {
        story.authors.forEach(author => !authorList.some(a => a.id === author.id) && authorList.push(author));
      });
    });
  }

  if (fillerStoryAuthors && fillerStoryAuthors.length) {
    fillerStoryAuthors.forEach(author => !authorList.some(a => a.id === author.id) && authorList.push(author));
  }

  return authorList.filter(c => c.slug !== "admin");
};

const SectionPageView = ({
  data,
  publicationStoriesObj,
  setPublicationStories,
  setLoading,
  entityList,
  headerMenuLinks
}) => {
  const [publicationStoryList, setPublicationStoryList] = useState([]);
  const collection = data.collection;
  const sectionId = get(collection, ["rules", "section-id"], "");
  const totalCount = collection["total-count"] || 0;
  const subCollections = collection.items.filter(item => item.type === "collection");
  const authors = getAllAuthors(data);
  const firstStory = collection.items.find(c => c.type === "story") || {};
  const subHeadline = get(firstStory, ["story", "subheadline"], null);
  const supporterTitle = get(collection, ["metadata", "support"], "Programme Funding");
  const peopleGrouping = get(collection, ["metadata", "people-grouping", "0", "key"], "no") === "yes";

  const filteredArray = headerMenuLinks.filter(item => item.title === "Programmes");
  const archivedItemList = filteredArray[0].children
    .filter(child => child.children && child.children.length > 0)
    .flatMap(child => child.children);
  const isTitleUnique = !archivedItemList.some(item => item.title === collection.name);
  const sectionName = get(collection, ["name"], "");

  const getImagesFromCards = () => {
    return (
      firstStory &&
      firstStory.story &&
      firstStory.story.cards &&
      firstStory.story.cards.reduce((accumulator, currentValue) => {
        const storyElements = currentValue["story-elements"];
        const imageElements = storyElements.filter(element => element.type === "image");
        accumulator = accumulator.concat(imageElements);
        return accumulator;
      }, [])
    );
  };
  let sectionData = {
    paymentLinks: [],
    photos: []
  };

  switch (sectionName) {
    case "CEROS":
      sectionData = {
        paymentLinks: ["https://rzp.io/rzp/DAiOpS9G", "https://rzp.io/rzp/HYmI5QV"],
        photos: [
          "https://images.assettype.com/ncfindia/2025-05-13/2n8aj536/SahyadriRaorchestesbombayensisRohitNaniwadekar-Rohit-Naniwadekar.JPG",
          "https://images.assettype.com/ncfindia/2025-05-13/sg9ekk8k/RohanMenziesFieldworkRiverBirdsArunachalPCRohitN-Rohit-Naniwadekar.jpg",
          "https://images.assettype.com/ncfindia/2025-05-13/h9qjo1jt/SahyadriNorthernWesternGhatsLandscapeIMG2019052909460303.jpg"
        ]
      };
      break;

    case "School for Science and Conservation":
      sectionData = {
        paymentLinks: ["https://rzp.io/rzp/t89IYxk", "https://rzp.io/rzp/YSBHodC"],
        photos: [
          " https://images.assettype.com/ncfindia/2025-05-13/anw2c2f1/1-Mousumi-Ghosh.JPG",
          "https://images.assettype.com/ncfindia/2025-05-13/du2x5i08/SVLtibia-Mousumi-Ghosh.jpg",
          "https://images.assettype.com/ncfindia/2025-05-13/tnq6vn99/Photo2PhotographedbyMayureshganngal-Mousumi-Ghosh.jpg"
        ]
      };
      break;

    case "Western Ghats":
      sectionData = {
        paymentLinks: ["https://rzp.io/rzp/LywLKtgb", "https://rzp.io/rzp/sZ8gtYl"],
        photos: [
          "https://images.assettype.com/ncfindia/2025-05-13/8stg6guv/people-Elephants-2023Photo-by-Ganesh-RaghunathanNCF-T-R-Shankar-Raman.jpg",
          "https://images.assettype.com/ncfindia/2025-05-13/5t2btiim/Measuringbuttressedrainforesttree-T-R-Shankar-Raman.jpg",
          "https://images.assettype.com/ncfindia/2025-05-13/q2ldnlai/VishalSadekarandHimanshuLadcollectsoilsamplefromMaharashtrarestorationsitepicbyKarthikTeegalapalli.jpeg"
        ]
      };
      break;

    case "Oceans and Coasts":
      sectionData = {
        paymentLinks: ["https://rzp.io/rzp/Cf9xcX7m", "https://rzp.io/rzp/UqYcp1k"],
        photos: [
          " https://images.assettype.com/ncfindia/2025-05-13/1xyj950c/IMG1245Rohan-Arthur.jpg",
          "https://images.assettype.com/ncfindia/2025-05-13/ourb8wob/5-Years-of-research-conducted-by-our-divers-on-Lakshadweeps-reefs-provide-us-with-critical-data-regarding-the-changes-taking-place-in-the-island-ecosystem-Mayukh-Dey.jpg",
          "https://images.assettype.com/ncfindia/2025-05-13/k9il8d0p/8-Marine-life-thrives-on-top-of-these-Acropora-and-Pocillopora-corals-in-a-Lakshadweep-lagoon.jpg"
        ]
      };
      break;

    case "Eastern Himalaya":
      sectionData = {
        paymentLinks: ["https://rzp.io/rzp/YJYsjXD", "https://rzp.io/rzp/QXoalmH", "null"],
        photos: [
          "https://images.assettype.com/ncfindia/2025-05-13/uricuf24/Great-hornbill-maleImage-by-Aparajita-Datta.JPG",
          "https://images.assettype.com/ncfindia/2025-05-13/enp2v3d6/ADChisocheton-cumingianusFruit-and-Seed-1.JPG",
          "https://images.assettype.com/ncfindia/2025-05-13/zn0kix3b/Wreathed-hornbillroostingBuxaTRSitaramMahato-2.JPG"
        ]
      };
      break;

    case "Endangered Birds":
      sectionData = {
        paymentLinks: ["https://rzp.io/rzp/5DnVLDK", "https://rzp.io/rzp/7Puvmsc"],
        photos: [
          "https://images.assettype.com/ncfindia/2025-05-13/zc5hcxxf/Sec-80-Gschool-kids-watching-birds-in-valparai.jpg",
          "https://images.assettype.com/ncfindia/2025-05-13/4ppjwb5t/Sec-35Endangered-Birds-Blackbellied-Ternphoto-by-Teja-YIMG2373.JPG",
          "https://images.assettype.com/ncfindia/2025-05-13/7qmamza8/FCRAJerdons-Courser.jpg"
        ]
      };
      break;

    case "High Altitudes":
      sectionData = {
        paymentLinks: ["https://rzp.io/rzp/stPFmKW0", "https://rzp.io/rzp/ED5q3G7M"],
        photos: [
          "https://images.assettype.com/ncfindia/2025-05-13/u93e9k1d/Photo-credits-Kesang-Chunit-NCF-HAP-Vindhya-Jyoti.JPG",
          "https://images.assettype.com/ncfindia/2025-05-13/rxlzcyle/Women-in-Conservation3-Photo-credits-HAP-NCF-Vindhya-Jyoti.jpg",
          " https://images.assettype.com/ncfindia/2025-05-13/mx409gvr/MunibIMG0035.JPG"
        ]
      };
      break;

    case "Education and Public Engagement":
      sectionData = {
        paymentLinks: ["https://rzp.io/rzp/Ko3bdEv3", "https://rzp.io/rzp/qSWAr0V1"],
        photos: [
          " https://images.assettype.com/ncfindia/2025-05-13/ezlzimet/80G.jpeg",
          "https://images.assettype.com/ncfindia/2025-05-13/8fpb6b9c/Sec-35.jpg",
          " https://images.assettype.com/ncfindia/2025-05-13/71r2yp7z/FCRA.jpg"
        ]
      };
      break;

    case "Conservation Social Sciences":
      sectionData = {
        paymentLinks: ["https://rzp.io/rzp/3JSmsyhU", " https://rzp.io/rzp/qh3bobi"],
        photos: [
          "https://images.assettype.com/ncfindia/2025-05-15/68s09g7v/DSC05102.JPG",
          "https://images.assettype.com/ncfindia/2025-05-15/85ggxfpd/DSC01541.jpg",
          "https://images.assettype.com/ncfindia/2025-05-15/n65a14vb/20161024111140.jpg"
        ]
      };
      break;

    default:
      sectionData = {
        paymentLinks: [],
        photos: []
      };
  }

  useEffect(() => {
    // Check if section id exists in publicationStoriesObj (store object)
    if (sectionId in publicationStoriesObj) {
      setPublicationStoryList(publicationStoriesObj[sectionId]);
    } else {
      setLoading(true);
      const MAX_LIMIT = 150; // Max stories to fetch in a API call
      let totalRecords = totalCount; // Backup the total count in a variable
      let temp = 0;
      let offset = 0;
      const list = [];
      const storyApiCallbackList = [];

      // Below while loop prepares the limit and offset
      // Example if totalCount is 550 and MAX_LIMIT is 200 then
      // list will have [{ limit: 200, offset: 0}, { limit: 200, offset: 200}, { limit: 150, offset: 400}]
      while (totalRecords > 0) {
        temp = totalRecords - MAX_LIMIT;

        if (temp > 0) {
          list.push({ limit: MAX_LIMIT, offset });
          offset += MAX_LIMIT;
        } else {
          list.push({ limit: totalRecords, offset });
          offset += totalRecords;
        }

        totalRecords = totalRecords - MAX_LIMIT;
      }

      for (let index = 0; index < list.length; index++) {
        const element = list[index];
        storyApiCallbackList.push(getSectionStories(sectionId, element.limit, element.offset));
      }

      Promise.all(storyApiCallbackList)
        .then(results => {
          const stories = [].concat.apply([], results);

          setPublicationStories(sectionId, stories);
        })
        .finally(() => setLoading(false));
    }
  });

  const images = getImagesFromCards();
  const children =
    images &&
    images.map((image, index) => (
      <div key={`image-${index}`} styleName="carousel-wrapper">
        <CardImageType2 image={image} />
        <div styleName="image-details">
          <p styleName="image-attribution">{image["image-attribution"]}</p>
        </div>
      </div>
    ));

  const partnerEntities = get(collection, ["metadata", "entities", "collectionEntities", "Partner"], []);

  const getFunderEntities = () => {
    const funderEntities1 = get(collection, ["metadata", "entities", "collectionEntities", "Funder"], []);
    const newList = [];

    funderEntities1.filter(c => c).forEach(element => {
      const obj = entityList.find(c => c.id === element.id);

      if (obj) {
        newList.push(obj);
      }
    });

    if (!newList.length) {
      return null;
    }

    return (
      <div className="container" styleName="entities">
        <Headline text={supporterTitle} headerLevel={2} headerType={9} />
        <Entities entities={newList} />
      </div>
    );
  };

  return (
    <div>
      <div styleName="wrapper">
        <div styleName="section-header">
          {collection.name && <Headline text={collection.name} headerType={3} headerLevel={2} />}
        </div>

        {images &&
          images.length > 1 && (
            <Carousel
              carouselName={`carousel-${collection.slug}`}
              options={{
                type: "carousel",
                perView: 1,
                autoplay: 3000,
                gap: 24
              }}
              totalItems={images.length}
              showArrows={false}
              showDots={true}
              renderCenterLeftControls={({ previousSlide, currentSlide }) => {
                return (
                  currentSlide !== 0 && (
                    <button onClick={previousSlide} className="slider-btn">
                      <Arrow2 />
                    </button>
                  )
                );
              }}
              renderCenterRightControls={({ nextSlide }) => (
                <button onClick={nextSlide} className="slider-btn">
                  <Arrow1 />
                </button>
              )}
            >
              {children}
            </Carousel>
          )}
        {images && images.length === 1 && children}

        {subHeadline && (
          <p className="container" styleName="subheadline">
            {subHeadline}
          </p>
        )}
        <div className="container" styleName="sub-collection">
          <Subcollections collections={subCollections} />
        </div>

        {isTitleUnique && sectionName !== "Partnerships" && <SupportBanner sectionData={sectionData} />}
        <div styleName="authors-wrapper" className="container">
          <PeopleTeamRow authors={authors} showAlumnus={peopleGrouping} isGropuBy={peopleGrouping} />
        </div>

        {getFunderEntities()}

        {partnerEntities.length > 0 && (
          <div className="container" styleName="entities">
            <Headline text="Partners" headerLevel={2} headerType={9} />
            <Entities entities={partnerEntities} />
          </div>
        )}

        <div className="container">
          <PublicationsRow isCollection={false} storyList={publicationStoryList} />
        </div>
      </div>
    </div>
  );
};

SectionPageView.propTypes = {
  data: object,
  publicationStoriesObj: object,
  setPublicationStories: func,
  setLoading: func,
  entityList: array,
  headerMenuLinks: array
};

const mapStateToProps = state => {
  return {
    publicationStoriesObj: get(state, ["publicationStoriesReducer"], {}),
    entityList: get(state, ["entityReducer"], []),
    headerMenuLinks: get(state, ["qt", "data", "navigationMenu", "headerMenuLinks"], [])
  };
};

const mapDispatchToProps = dispatch => ({
  setPublicationStories: (key, value) => dispatch(setPublicationStories(key, value)),
  setLoading: isLoading => dispatch(setLoading(isLoading))
});

const SectionPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(SectionPageView);

export { SectionPage };
